import { createContext } from 'react';

export const AuthenticationPageContext = createContext(undefined);
